module.exports = __webpack_public_path__ + "img/jcb.3dc6afe4.svg";